import React, {useState} from 'react';
import BBIconQuestionHandRequest from "../../assets/bbCustomIcons/BBIconQuestionHandRequest";
import {useDispatch, useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf, bbFindUserTagsByTagId} from "../../util/bbHelpers";
import {useLocation} from "react-router-dom";
import {IconButton, Paper} from "@mui/material";
import {removeTagsForToursNew, removeTagsForToursTutorial, startProductTour} from "../../actions";
import {Col, Row} from "reactstrap";
import {Button, Popper} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {indexOfToursMeta} from "./indexOfTours";

const RelaunchTourPopper = ({open = false,}) =>{

    const [popoverOpen, setPopoverOpen] = useState(open)

    const handleClose = () =>{
        setPopoverOpen(false);
    }

    return(
        <Popper open={popoverOpen}
                anchorEl={document.querySelector("#relaunchTourButton")}
                placement={"top-start"}
                transition
                style={{zIndex: 1502, maxWidth: "500px",}}
        >
            <Paper className={"text-center p-2 m-2 bg-primary text-white animation-duration-10 fadeIn"}
                   elevation={24}
                   style={{minHeight: "100px", zIndex: "50", borderRadius: "0", opacity: "90%"  }}>
                <div>
                    <Row className={"text-right m-0 p-0"}>
                        <Col className={"m-0 p-0"}>
                            <IconButton
                                onClick={handleClose}
                                className={"m-0 p-0"}
                            >
                                <CloseIcon className={"close text-white"}/>
                            </IconButton>
                        </Col>
                    </Row>
                    <Row className={"my-0 py-0 mb-1 pb-1"}>
                        <Col className={"m-0 p-0"}>
                            <h2 className={"text-center m-0 p-0"}>
                                Want to see this tour again?
                            </h2>
                        </Col>
                    </Row>
                    <Row className={"mx-2 px-2 mb-1 pb-1"}>
                        <Col>
                            Click this icon on any page to view the tour again.
                        </Col>
                    </Row>
                    <Row className={"text-center"}>
                        <Col>
                            <Button onClick={handleClose}
                                    variant={"contained"}
                                    className={"bg-secondary text-white"}
                            >Okay</Button>
                        </Col>
                    </Row>
                </div>
            </Paper>
        </Popper>
    )
}


const LaunchTourIconButton = ({className = null,}) =>{

    const location = useLocation();
    const dispatch = useDispatch();

    const {authUser} = useSelector(({auth})=>auth);
    const { didJustAddTourTag } = useSelector(({auth}) => auth.appMisc);
    const {portfolios, entityInView, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
    const {customers, customerInView, loadingCustomers} = useSelector(({customer})=> customer);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    const customer = customers && customerInView && customers[customerInView] ? customers[customerInView] : null;

    const pagesWithTours = indexOfToursMeta && indexOfToursMeta.tourPagesSet

    // console.log("Pages with tours", pagesWithTours)

    const userTourTagsNew = bbFindUserTagsByTagId(authUser, 62);
    const userTourTagsTutorial = bbFindUserTagsByTagId(authUser, 61);

    const userToursTagsNewForPage = userTourTagsNew
        && userTourTagsNew
            .filter((tag)=> tag.details === location.pathname);
    const userToursTagsTutorialForPage = userTourTagsTutorial
        && userTourTagsTutorial
            .filter((tag)=> tag.details === location.pathname);

    const hasHadTourForPage = userToursTagsNewForPage && userToursTagsTutorialForPage && (userToursTagsTutorialForPage.length > 0 || userToursTagsNewForPage.length > 0);

    const userFirstLogin = authUser
        && authUser.user
        && authUser.user.first_login;

    const userShowTutorial = authUser
        && authUser.user
        && authUser.user.show_tutorial;

    const handleClick = () =>{
        if(userToursTagsTutorialForPage.length > 0){
            const tag = userToursTagsTutorialForPage[0];
            const tagId = tag && tag.id
            if(!userFirstLogin && !userShowTutorial){
                dispatch(startProductTour(location.pathname))
            }
            console.log("removing tutorial tour tag", tag, tagId)
            dispatch(removeTagsForToursTutorial(tag));
        } else if (userToursTagsNewForPage > 0){
            const tag = userToursTagsNewForPage[0];
            const tagId = tag && tag.id;
            console.log("removing new tour tag", tag, tagId);
            dispatch(removeTagsForToursNew(tag));
        } else{
            console.log("Find a way to launch tours for people already in the app without tags", location.pathname)
            dispatch(startProductTour(location.pathname))
        }

    }
    const [open, setOpen] = useState(didJustAddTourTag[location.pathname]);

    if(pagesWithTours.has(location.pathname)){
        return(
         <span title={"Tour this page."} className={"pulse"}>
                <IconButton onClick={()=>handleClick()}
                        className={`${className ? className : ""} text-white animated animation-duration-40 pulse pulse-slow`}
                        id={"relaunchTourButton"}>
                <BBIconQuestionHandRequest className={`${className ? className : ""}`}
                                           />
            </IconButton>
            <RelaunchTourPopper open={open}/>
        </span>
    )
    } else{
        return null;
    }
}

export default LaunchTourIconButton;